import React from 'react';
import { BasicDropdown, Icon } from '../../../components';

const MassiveActions = ({ handleClick = () => {}, disabled }) => {
  const actions = () => {
    const authorizedActions = [];

    authorizedActions.push({
      icon: <Icon icon="file-earmark-excel" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'download_excel',
      props: {
        onClick: () => handleClick('download_excel'),
        disabled
      },
      title: 'Descargar Excel'
    });

    authorizedActions.push({
      icon: <Icon icon="trash" height="16px" width="16px" style={{ marginRight: 5 }} />,
      key: 'destroy',
      props: {
        onClick: () => handleClick('destroy'),
        disabled
      },
      title: 'Eliminar'
    });

    return authorizedActions;
  };

  return (
    <div className="mb-4">
      <BasicDropdown
        block
        items={actions()}
        noArrow
        right
        titleDrop={
          <span className="align-middle">
            Acciones Masivas <Icon icon="ellipsis-vertical" height="20px" width="20px" />
          </span>
        }
        variant="outline-primary"
      />
    </div>
  );
};

export default MassiveActions;
